import React from "react";
import { useTranslation } from "react-i18next";
import MaxWidthContainer from "../../../components/UI/MaxWidthContainer/MaxWidthContainer";
import { useGetRecipesQuery } from "../../../providers/recipes";
import Page from "../../page-layout";
import { BackButton } from "@core/components";
import RecipesViewList from "./recipeViewList";

const RecipePage = () => {
  const { t } = useTranslation();
  const { data: recipes = [] } = useGetRecipesQuery();

  return (
    <Page>
      <Page.Header className="pt-[env(safe-area-inset-top)]">
        <MaxWidthContainer classList="flex items-center bg-white h-16">
          <div className="grid grid-cols-3 items-center text-center w-full px-2.5">
            <BackButton buttonStyles="justify-self-start ml-0" />
            <div className="">{t("Recipes")}</div>
          </div>
        </MaxWidthContainer>
      </Page.Header>
      <Page.Content>
        <MaxWidthContainer>
          <RecipesViewList recipes={recipes} />
        </MaxWidthContainer>
      </Page.Content>
    </Page>
  );
};

export default RecipePage;
